const Rain = (props) => (
  <svg
    width="38"
    height="39"
    viewBox="0 0 38 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26.125 29.6875L26.125 28.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 32.0625L19 30.875"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 38L19 36.8125"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.875 29.6875L11.875 28.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.875 35.625L11.875 34.4375"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.125 35.625L26.125 34.4375"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0625 13.6563C13.0625 11.6599 13.6545 9.70838 14.7636 8.04847C15.8727 6.38856 17.4492 5.09482 19.2935 4.33085C21.1379 3.56687 23.1675 3.36698 25.1255 3.75645C27.0834 4.14592 28.882 5.10726 30.2936 6.5189C31.7053 7.93053 32.6666 9.72907 33.0561 11.6871C33.4455 13.6451 33.2456 15.6746 32.4817 17.519C31.7177 19.3634 30.424 20.9398 28.764 22.0489C27.1041 23.158 25.1526 23.75 23.1563 23.75H11.2813C10.333 23.7492 9.39619 23.5419 8.53608 23.1425C7.67598 22.7431 6.91316 22.1613 6.30065 21.4373C5.68813 20.7133 5.24062 19.8647 4.98921 18.9503C4.73779 18.0359 4.68851 17.0778 4.84479 16.1424C5.00107 15.2071 5.35916 14.317 5.89417 13.534C6.42917 12.751 7.12827 12.094 7.94286 11.6084C8.75746 11.1229 9.66801 10.8206 10.6112 10.7225C11.5545 10.6245 12.5077 10.7329 13.4048 11.0405"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Rain
